<template>
  <div v-if="pagination.itemsLength !== 0">
    <v-divider />
    <v-sheet
      color="white"
      class="d-flex justify-space-between pa-3"
    >
      <div>
        <v-tooltip right color="grey darken-4">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-menu top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    color="grey lighten-2"
                    elevation="0"
                    class="text-capitalize"
                  >
                    {{ itemsPerPage.text }}
                  </v-btn>
                </template>
                <v-list dense class="py-0">
                  <v-list-item-group v-model="pagination.itemsPerPage" color="primary">
                    <v-list-item
                      v-for="item in pagination.itemsPerPageOptions"
                      :key="item.value"
                      :value="item.value"
                      @click="setItemsPerPage(item.value)"
                    >
                      <v-list-item-title class="text-right">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </template>
          <span color="black">{{ pagination.itemsPerPageText || 'Rows per page' }}</span>
        </v-tooltip>
      </div>
      <v-spacer />
      <div class="d-flex align-center justify-end">
        <v-btn @click="previousPage" :disabled="parseInt(pageStart, 10) === 1" icon small color="primary">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <div
          class="mx-1 subtitle-2 grey--text text--darken-2"
        >
          {{ pageStart }} - {{ pageStop }} / {{ parseInt(pagination.itemsLength, 10) }}
        </div>
        <v-btn
          @click="nextPage"
          :disabled="parseInt(pageStop, 10) === parseInt(pagination.itemsLength, 10)"
          icon
          small
          color="primary"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'CustomPagination',
  props: {
    pagination: {
      type: Object,
      required: true,
      default: () => ({
        page: 1,
        itemsLength: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 15, text: 15 },
          { value: -1, text: 'All' }
        ],
        itemsPerPageText: 'Rows per page'
      })
    }
  },
  data: () => ({}),
  computed: {
    itemsPerPage () {
      return this.pagination.itemsPerPageOptions.find(
        item => parseInt(item.value, 10) === parseInt(this.pagination.itemsPerPage, 10)
      )
    },
    pageStart () {
      return (parseInt(this.pagination.page, 10) - 1) * parseInt(this.pagination.itemsPerPage, 10) + 1
    },
    pageStop () {
      if (parseInt(this.pagination.itemsPerPage, 10) !== -1) {
        if (
          parseInt(this.pagination.page, 10) * parseInt(this.pagination.itemsPerPage, 10) >
          parseInt(this.pagination.itemsLength, 10)
        ) {
          return parseInt(this.pagination.itemsLength, 10)
        }
        return parseInt(this.pagination.page, 10) * parseInt(this.pagination.itemsPerPage, 10)
      }
      return parseInt(this.pagination.itemsLength, 10)
    }
  },
  watch: {
    'pagination.page': function () { this.$emit('change') },
    'pagination.itemsPerPage': function () { this.$emit('change') },
    'pagination.sortBy': function (newVal, oldVal) {
      if (newVal && oldVal && this.pagination.sortDesc) {
        this.$emit('sort')
      }
    },
    'pagination.sortDesc': function () { this.$emit('sort') }
  },
  methods: {
    previousPage () {
      if (this.pagination.page > 1) {
        this.pagination.page -= 1
      }
    },
    nextPage () {
      if (
        parseInt(this.pagination.page, 10) <
        Math.ceil(
          parseInt(this.pagination.itemsLength, 10) / parseInt(this.pagination.itemsPerPage, 10)
        )
      ) {
        this.pagination.page += 1
      }
    },
    setItemsPerPage (value) {
      this.pagination.itemsPerPage = value
      this.pagination.page = 1
    }
  }
}
</script>

<style lang="css" scoped>
</style>
